import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SystemAiPrompt from './system-ai-prompt';
import SystemAiPromptDetail from './system-ai-prompt-detail';
import SystemAiPromptUpdate from './system-ai-prompt-update';
import SystemAiPromptDeleteDialog from './system-ai-prompt-delete-dialog';

const SystemAiPromptRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SystemAiPrompt />} />
    <Route path="new" element={<SystemAiPromptUpdate />} />
    <Route path=":id">
      <Route index element={<SystemAiPromptDetail />} />
      <Route path="edit" element={<SystemAiPromptUpdate />} />
      <Route path="delete" element={<SystemAiPromptDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SystemAiPromptRoutes;
